import {
    AdmissionAnaesthetistDropdown,
    AdmissionConsultantDropdown,
    AdmissionSpecialtiesDropdown,
    AdmissionSurgeonDropdown,
} from '../../../../controls/agyle/dictionaries';
import {
    getConfig,
    getConsultantsFilter,
    getFilterAnaestheticType,
    getFilterPriority,
    getSpecialtiesFilter, getSurgeonsFilter, setAnaesthetistsFilter,
    setConsultantsFilter,
    setDefaultFilterToMe,
    setFilterAnaestheticType,
    setFilterPriority,
    getAnaesthetistsFilter,
    setSpecialtiesFilter, setSurgeonsFilter,
} from '../../../../store/reducers/booked_admissions';
import {MenuItem} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import {agylePref} from '../../../../store/reducers/preferences';
import AgyleSwitch from '../../../../components/ui/switch/agyleSwitch';
import {user} from '../../../../store/reducers/user';
import API from '../../../../app/api';
import _ from 'lodash';

export const useStyles = makeStyles((theme) => ({
    filterName: {
        fontSize: "14px",
        fontWeight: 800,
        marginBottom: "5px",
        marginLeft: "10px"
    },
    fontInter: {
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "15px"
    },
    menuItem: {
        padding: 0,
        fontSize: 12,
    },
}));

const AdmissionFilterModal = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const admissionConfig = useSelector(getConfig);
    const specialtiesFilter = useSelector(getSpecialtiesFilter);
    const consultantsFilter = useSelector(getConsultantsFilter);
    const surgeonsFilter = useSelector(getSurgeonsFilter);
    const anaesthetistsFilter = useSelector(getAnaesthetistsFilter);

    const priority =  useSelector(getFilterPriority);
    const anaestheticType = useSelector(getFilterAnaestheticType)
    const userObject = useSelector(user);

    const [userIsCons, setUserIsCons] = useState(false);
    const [userIsSurgeon, setUserIsSurgeon] = useState(false);
    const [userIsAnaesthetists, setUserIsAnaesthetists] = useState(false);

    useEffect(()=>{
        getConsultantByUserName();
    },[]);

    const getConsultantByUserName = () => {
        let urlConsultant = `/admission/person/consultant?userName=${userObject.userName}`;
        let urlSurgeon = `/admission/person/surgeon?userName=${userObject.userName}`;
        let urlAnaesthetist = `/admission/person/anaesthetist?userName=${userObject.userName}`;

        API.getDictByURL(urlConsultant).then(dictData => {
            if (dictData && !_.isEmpty(dictData)) {
                setUserIsCons(true)
            }
        }).catch(function (error) {
            console.error("Consultant Filter", error);
        });

        API.getDictByURL(urlSurgeon).then(dictData => {
            if (dictData && !_.isEmpty(dictData)) {
                setUserIsSurgeon(true)
            }
        }).catch(function (error) {
            console.error("Surgeons Filter", error);
        });

        API.getDictByURL(urlAnaesthetist).then(dictData => {
            if (dictData && !_.isEmpty(dictData)) {
                setUserIsAnaesthetists(true)
            }
        }).catch(function (error) {
            console.error("Anaesthetists Filter", error);
        });
    }


    const FILTER_STATUS = {
        valid: "valid",
        notValid: "notValid",
        notReq: "notReq"
    }

    const filterIsSetToMe = () => {

        function checkFilterStatus(userHasRole, filterList) {
            let filterStatus = FILTER_STATUS.notReq;

            if(userHasRole) {
                filterStatus = FILTER_STATUS.notValid;
                if(filterList.length > 0 && !filterList.some((con) => con.userName !== userObject.userName))
                    filterStatus = FILTER_STATUS.valid;
            } else if(filterList.length > 0) {
                filterStatus = FILTER_STATUS.notValid;
            }

            return filterStatus;
        }

        let consultantFilterCorrect = checkFilterStatus(userIsCons, consultantsFilter);
        let surgeonsFilterCorrect = checkFilterStatus(userIsSurgeon, surgeonsFilter);
        let anaesthetistsFilterCorrect = checkFilterStatus(userIsAnaesthetists, anaesthetistsFilter);

        return consultantFilterCorrect !== FILTER_STATUS.notValid  && surgeonsFilterCorrect !== FILTER_STATUS.notValid && anaesthetistsFilterCorrect !== FILTER_STATUS.notValid
    }

    return  <div style={{display: "inline-flex", width: "100%", marginBottom: 20, gap: 30, justifyContent: "space-evenly"}}>
        <div style={{gap: 15}}>


            <AdmissionSpecialtiesDropdown
                name="AdmissionSpecialties"
                label={"Specialties"}
                color="primary"
                size={"small"}
                multiple
                inputWithTag
                value={specialtiesFilter}
                background={"#523E61"}
                inputProps={{
                    style: {
                        borderRadius: 5
                    },
                }}
                onChange={(e) => dispatch(setSpecialtiesFilter(e))}
            />

            <div style={{height: 20}}/>
            <AdmissionConsultantDropdown
                name="AdmissionConsultant"
                color="primary"
                size={"small"}
                label={t('Overseeing Consultant')}
                multiple
                background={"#3E5C61"}
                disabed
                inputWithTag
                value={consultantsFilter}
                onChange={(el)=>{dispatch(setConsultantsFilter(el))}}
            />

            <div style={{height: 20}}/>
            <AdmissionSurgeonDropdown
                name="AdmissionSurgeon"
                color="primary"
                size={"small"}
                label={'Surgeon'}
                multiple
                background={"#40613e"}
                disabed
                inputWithTag
                value={surgeonsFilter}
                onChange={(el)=>{dispatch(setSurgeonsFilter(el))}}
            />
            <div style={{height: 20}}/>
            <AdmissionAnaesthetistDropdown
                name="AdmissionAnaesthetist"
                label={"Anaesthetist"}
                multiple
                inputWithTag
                color="primary"
                background={"#61593e"}
                value={anaesthetistsFilter}
                onChange={(el)=>{dispatch(setAnaesthetistsFilter(el))}}
            />
            <div style={{height: 20}}/>

            <AgyleSwitch
                name={"defaultConsultantToMe"}
                value={filterIsSetToMe()}
                disabled={!(userIsCons || userIsSurgeon || userIsAnaesthetists)}
                onChange={(el) => {
                    if(filterIsSetToMe()){
                        dispatch(setConsultantsFilter([]))
                        dispatch(setSurgeonsFilter([]))
                        dispatch(setAnaesthetistsFilter([]))
                    } else {
                        dispatch(setDefaultFilterToMe(userObject.userName))
                    }
                }}
                label={'Show only my patients and sessions'}
            />
        </div>

        <div style={{ width: "23%"}}>
            <div className={classes.filterName}>Priority</div>
            {admissionConfig?.priority?.map((option) => (
                <MenuItem key={option?.__id} value={option}
                          onClick={()=>{
                              let newPriority = [];
                              if(priority?.includes(option)) newPriority = priority.filter((el) => el.description !== option.description)
                              else newPriority = [...priority, ...[option]];

                              dispatch(setFilterPriority(newPriority));
                          }}
                          className={classes.menuItem}>
                    <Checkbox
                        checked={priority?.includes(option)}
                        disableRipple
                        onChange={(e) => {
                            let newPriority = [];
                            if(priority?.includes(option)) newPriority = priority.filter((el) => el.description !== option.description)
                            else newPriority = [...priority, ...[option]];

                            dispatch(setFilterPriority(newPriority));
                        }}
                    />
                    <div> {option.description} </div>
                </MenuItem>
            ))}
        </div>
        <div style={{ width: "25%"}}>
            <div className={classes.filterName}>Anaesthetic Type</div>
            {admissionConfig?.anaestheticType?.map((option) => (
                <MenuItem key={option?.__id} value={option}
                          onClick={()=>{
                              let newPriority = [];
                              if(anaestheticType?.includes(option)) newPriority = anaestheticType.filter((el) => el.description !== option.description)
                              else newPriority = [...anaestheticType, ...[option]];

                              dispatch(setFilterAnaestheticType(newPriority));
                          }}
                          className={classes.menuItem}>
                    <Checkbox
                        checked={anaestheticType?.includes(option)}
                        disableRipple
                        onChange={(e) => {
                            let newPriority = [];
                            if(anaestheticType?.includes(option)) newPriority = anaestheticType.filter((el) => el.description !== option.description)
                            else newPriority = [...anaestheticType, ...[option]];

                            dispatch(setFilterAnaestheticType(newPriority));
                        }}
                    />
                    <div> {option.description} </div>
                </MenuItem>
            ))}
        </div>
    </div>
}
export default AdmissionFilterModal